/**
 * MyAccountAccess Component
 */

(function () {

    'use strict';

    /**
     * Parent component for controlling components like login, register & resetPassword
     */
    var ItxUserAccessCmp = {
        bindings: {
            closeDialog: '&',
            data: '=',
            guestTokens:'<'
        },
        transclude: true,
        controller: ItxUserAccessCmpCtrl,
        controllerAs: 'userAccessCtrl',
        templateUrl: 'user-access.tpl'
    };

    ItxUserAccessCmpCtrl.$inject = [
        '$rootScope',
        'ItxErrorMessagesFct',
        'ItxScreenSizeSvc',
        '$scope',
        'ItxHeaderFct',
        'ngDialog',
        '$timeout',
        'ItxShareDataFct',
        'imAccessService',
        'imDispatcherService',
        'ItxSocialLoginSvc'];
        /** Public */
        angular.module('itxApp.common')
            .component('itxUserAccess', ItxUserAccessCmp);

    function ItxUserAccessCmpCtrl(
        $rootScope, 
        ItxErrorMessagesFct, 
        ItxScreenSizeSvc, 
        $scope,
        ItxHeaderFct, 
        ngDialog, 
        $timeout,
        ItxShareDataFct, 
        imAccessService,
        imDispatcherService,
        ItxSocialLoginSvc
    ) {
        var _this = this;
        _this.$scope = $scope;
        _this.$timeout = $timeout;
        _this.activationCode = null;
        _this.itxErrorMessagesFct = ItxErrorMessagesFct;

        ItxErrorMessagesFct.reset('userAccessCtrl', 'ERROR');

        _this.preselectedFields = _this.data.preselectedFields;

        _this.accessingToViewOrders = (_this.data == 'in-order-tracking-access');

        if(document.location.href.indexOf('my-account')>-1){
            _this.myAccountLogin = true;
        }

        if (_this.data !== 'side' && _this.data !== 'in-order-tracking-access') {
            var unsuscribeScreenSize = $scope.$on('screen-size:desktop', function () {
                if (_this.activeSection === 'login') {
                    ItxHeaderFct.toggleLogin();
                    _this.$timeout(function () {
                        _this.closeDialog();
                        ItxErrorMessagesFct.reset('userAccessCtrl','ERROR');
                    });
                }
            });
        }

        _this.$onInit = function () {
            inditex.onReady(function () {
                _this.checkSocialLogin();
            }); 
        };

        _this.$onDestroy = function () {
            if (unsuscribeScreenSize) {
                unsuscribeScreenSize();
            }
        };

        if (_this.data && _this.data.toString() === 'change-password') {
            _this.activeSection = 'change-password';
            imAccessService.createView('acceso','recuperar_contrasena/modificar');
        } else if (_this.data && _this.data.toString() === 'register') {
            _this.activeSection = 'register';
        } else if (_this.data && _this.data.toString() === 'recover-password') {
            _this.activeSection = 'recover-password';
            /**
             * IMAnalyics  Perfil usuario - Recuperar contrasena
             */
            imAccessService.createView('acceso','recuperar_contrasena');

        // En caso de ser un popup de recuperación de contraseña debido a expiración de enlace
        } else if (_this.data && _this.data.toString() === 'recover-password-expired-link') {
            // Define la propiedad "isExpiredLink" para pasar al componente itxResetPassword
            _this.isExpiredLink = true;
            _this.activeSection = 'recover-password';
            /**
             * IMAnalyics  Perfil usuario - Recuperar contrasena
             */
            imAccessService.createView('acceso', 'recuperar_contrasena');

        }
        else if(_this.data && _this.data.action && _this.data.action === 'register'){
            _this.activeSection = 'register';
        }
        else {
            _this.activeSection = 'login';
        }

        _this.checkSocialLogin = function(){
            ItxSocialLoginSvc.checkSocialLogin().then(function(data){
                if(data){
                    _this.isSocialLogin = true;
                } else {
                    _this.isSocialLogin = false;
                } 
            });
        };

        _this.openPolicy = function(){
            window.open(inditex.getStaticResourceUrl('pdf/privacy_policy/' + inditex.iStoreId + '/privacy_policy' + inditex.iLangId + '.pdf'), '_blank');
        };

        _this.isActive = function (what) {
            var sections = what.split(',');
            return sections.indexOf(_this.activeSection) !== -1;
        };

        _this.show = function (what) {
            
            _this.activeSection = what;
            ItxErrorMessagesFct.reset('userAccessCtrl', 'ERROR');

            /**
             * IMAnalytics
             */
            imAccessService.triggerView(what);
        };

        _this.updateLogin = function (login) {
            _this.login = login;
        };

        _this.showRegister = function () {
            ngDialog.open({
                template: 'user-access-dialog-wrapper.tpl',
                className: 'new-modal ma-modal-md ma-modal-macro  register-modal ngdialog-theme-plain ' ,
                showClose: true,
                bindToController: true,
                data: {
                    action:'register',
                    onRegister:function(){
                    _this.onRegister();
                }},
                preCloseCallback: function() {
                    imDispatcherService.sortEvent('pageview', null, null, 'login');
                }
            });
            //_this.closeDialog();

            /**
             * IMAnalyics IMAnalyics  Perfil usuario - Acceso Registro
             */
            imAccessService.triggerView('register');
        };
     

        _this.showRecover = function (email) {
            ItxShareDataFct.add('recover-password', email);
            /*if (ItxScreenSizeSvc.is('xs,sm')) {
                _this.activeSection = 'recover-password';
                imAccessService.createView('acceso', 'recuperar_contrasena');

            } else {*/
                ngDialog.open({
                    template: 'user-access-dialog-wrapper.tpl',
                    className: 'new-modal ma-modal-md ma-modal-macro recover-dialog ngdialog-theme-plain',
                    showClose: true,
                    bindToController: true,
                    data: 'recover-password',
                    preCloseCallback: function() {
                        imDispatcherService.sortEvent('pageview', null, null, 'login');
                    }
                });
                
                // Hotjar user behavior analytics
                if(typeof hj != 'undefined'){
                    hj('tagRecording', ['passwordrecovery']);
                }
                _this.closeDialog();
            /*}*/

        };

        _this.setActivationCode = function (activationCode) {
            _this.activationCode = activationCode;
        };

        _this.getActivationCode = function () {
            return _this.activationCode;
        };
    }




})();
